export default { sha: 'eca9ca5c771191ba54f43ae74196db7f2749f7be', buildNumber: 'undefined' }
